import React from "react";
import { AppBar, Toolbar } from "@mui/material";
import { whitecolor } from "../../style2";


  const toolbar = {
    minHeight: 100,
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: 3,
    paddingBottom: 3,
  };
  const appbar = {
    position: "static",
    background: whitecolor,
    //boxShadow: "none",
    //borderRadius: "0px 10px 10px 0px",
  };
  const registrationHeader = {
    width: 180,
  };


function Header() {

  return (
      <AppBar sx={appbar}>
        <Toolbar sx={toolbar}>
          <img
            style={registrationHeader}
            src='Logo_Option_1.svg'
            alt='logo'
          ></img>
        </Toolbar>
      </AppBar>
  );
}

export default Header;
